import { render, staticRenderFns } from "./NeoparentLogin.vue?vue&type=template&id=6f5abdc0&scoped=true"
import script from "./NeoparentLogin.vue?vue&type=script&lang=js"
export * from "./NeoparentLogin.vue?vue&type=script&lang=js"
import style0 from "./NeoparentLogin.vue?vue&type=style&index=0&id=6f5abdc0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5abdc0",
  null
  
)

export default component.exports